import TextLink from '@/components/TextLink';
import useTerms from '@/hooks/use-terms';

import styles from './DesktopFooter.module.scss';

// Static Allguth footer (AGB/Datenschutz/Impressum/copyright) for the desktop
// split-screen layout, matching meine.allguth.de. Logto's built-in terms
// links only cover ToS/privacy, so this is a dedicated component rather than
// an extension of TermsAndPrivacyLinks (which is also used, with different
// wording, inside the sign-in card itself).
const DesktopFooter = () => {
  const { termsOfUseUrl, privacyPolicyUrl } = useTerms();

  return (
    <div className={styles.footer}>
      <TextLink className={styles.link} href={termsOfUseUrl} type="secondary" target="_blank">
        AGB
      </TextLink>
      <TextLink className={styles.link} href={privacyPolicyUrl} type="secondary" target="_blank">
        Datenschutz
      </TextLink>
      <TextLink
        className={styles.link}
        href="https://allguth.de/impressum"
        type="secondary"
        target="_blank"
      >
        Impressum
      </TextLink>
      <span className={styles.copyright}>© ALLGUTH GmbH</span>
    </div>
  );
};

export default DesktopFooter;
